import Dexie, { Table } from 'dexie';
import { ProgressionState } from '../types/progression';

export interface DiaryEntry {
    id?: number;
    date: string;
    iv: string;
    ciphertext: string;
    createdAt: number;
}

export interface CraftCompletion { id: string; craftId: string; completedAt: number; photo?: Blob; }

export interface StoredRiddle {
    id: string;
    askedAt: number;
    solved: boolean;
}

export interface StoredClue {
    id: string;
    discoveredAt: number;
}

export interface MediaCompletion {
    mediaId: string;
    completedAt: number;
}

export interface MediaFavourite {
    mediaId: string;
    addedAt: number;
    title: string;
    type: 'book' | 'video';
    coverImage?: string;
    about?: string;
    identifier?: string;
    videoId?: string;
    author?: string;
    amazonUrl?: string;
}

export interface MediaSearchCache {
    query: string;
    results: any[];
    timestamp: number;
}

export class SparkleDatabase extends Dexie {
    // Tables
    progression!: Table<{ key: string; data: ProgressionState }, string>;
    diary!: Table<DiaryEntry, number>;
    riddles!: Table<StoredRiddle, string>;
    clues!: Table<StoredClue, string>;
    mediaCompletions!: Table<MediaCompletion, string>;
    mediaSearchCache!: Table<MediaSearchCache, string>;
    mediaFavourites!: Table<MediaFavourite, string>;
    crafts!: Table<CraftCompletion, string>;

    constructor() {
        super('SparkleWorldDB');

        // Define schema
        this.version(1).stores({
            progression: 'key',
            diary: '++id, date',
            riddles: 'id',
            clues: 'id'
        });

        this.version(2).stores({
            mediaCompletions: 'mediaId',
            mediaSearchCache: 'query'
        });

        this.version(3).stores({
            mediaFavourites: 'mediaId'
        });
        this.version(4).stores({ crafts: 'id, craftId, completedAt' });
    }
}

export const db = new SparkleDatabase();
